// Lucide icon: arrow-up-wide-narrow (https://lucide.dev/icons/arrow-up-wide-narrow)
import { ArrowUpWideNarrow } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconSortAscending = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowUpWideNarrow />
    </IconComponentStyled>
  )
}
